module.exports = __webpack_public_path__ + "img/pod.aa420b3e.png";